import axios from 'axios'

import { ILoadFile } from './types'

export const loadFile = async ({ url, ...params }: ILoadFile) => {
  if (params.print) {
    window.open(axios.getUri({ url, params }))
    return
  }

  const { data, headers } = await axios.get<Blob>(url, {
    responseType: 'blob',
    params
  })
  const contentDisposition = headers['content-disposition']

  const filename = contentDisposition?.match(
    /filename=[*'‘"]*(.*?)[*;'’"]/
  )?.[1]

  // Create blob link to download
  const href = window.URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = href

  link.setAttribute('download', filename ?? 'HRizer.pdf')

  document.body.appendChild(link)
  link.click()

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}
